import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { UserService } from './../../user.service';

@Component({
  selector: 'narwhalia-activation',
  template: ''
})
export class ActivationComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.userService.activate(params.resetKey).subscribe(result => {
        this.router.navigate(['/population']);
      });
    });
  }
}
